import React from "react";
import { Link, useLocation } from "react-router-dom";
import IconDownSide from "../svg/IconDownSide";

const Breadcrumbs = () => {
    const location = useLocation();
    const pathnames = location.pathname.split("/").filter((x) => x);

    const isFeedsPath = pathnames[0]?.toLowerCase() === "feeds";
    const isAnnotationSpacePath = pathnames[0]?.toLowerCase() === "annotation";

    const getBreadcrumbName = (name, payload) => {
        switch (name) {
            case "feeds":
                if (name === "feeds") {
                    return !payload?.isUnlinkable
                }
                break;
            case "annotation":
                if (name === "annotation") {
                    return !payload?.isAnnotationSpaceUnlinkable
                }
                break;

        }
    }

    return (
        <div className="breadcrumbs flex items-center gap-1">
            {pathnames?.length >= 2 && pathnames.map((name, index) => {
                const breadcrumbPath = `/${pathnames.slice(0, index + 1).join("/")}`;
                const isLast = index === pathnames.length - 1;

                // Decode and format the name
                const decodedName = decodeURIComponent(name.replace(/-/g, " "));

                // Condition: If on feeds path, make "Category" and "Test" unclickable
                const isUnlinkable = isFeedsPath && index > 0;
                const isAnnotationSpaceUnlinkable = isAnnotationSpacePath && index >= 0;

                const payload = {
                    isUnlinkable,
                    isAnnotationSpaceUnlinkable
                }

                return isLast ? (
                    // Last breadcrumb item (non-linkable, plain text)
                    <span key={breadcrumbPath} className="text-xs text-textV2 font-500 capitalize">
                        {decodedName}
                    </span>
                ) : (
                    <span key={breadcrumbPath} className="flex items-center gap-1">
                        {getBreadcrumbName(pathnames[0]?.toLowerCase(), payload) ? (
                            // Linkable intermediate breadcrumb items
                            <Link
                                to={breadcrumbPath}
                                className="text-xs text-themeV2 font-500 flex items-center gap-1 capitalize cursor-pointer"
                            >
                                {decodedName}
                            </Link>
                        ) : (
                            // Non-linkable intermediate breadcrumb items
                            <span className="text-xs text-textV2 font-500 capitalize">
                                {decodedName}
                            </span>
                        )}
                        <IconDownSide className="text-textV2 w-4 h-4 -rotate-90" />
                    </span>
                );
            })}
        </div>
    );
};

export default Breadcrumbs;
